import http from "~/assets/scripts/utils/http";
//import './ReceiptInfoApi.d';

export namespace CustomUploadApi {
    export const upload = (param: ICustomUploadParams, data: FormData, loadingOptions?: IRequestLoadingOption) =>
        http.sendFromData<IUploadViewModel>("Upload/Post", param, data)
    // request<IReceiptPartNos>({
    //     method: 'post',
    //     url: 'ReceiptInfo/GetPartNos',
    //     data: param,
    //     loadingOptions
    // })
    export const uploadFile = (param: ICustomUploadParams, file: File, loadingOptions?: IRequestLoadingOption) => {
        var frm = new FormData();
        frm.append("file", file);
        return upload(param, frm)
    }
    
    /** 获取上传的文件下载链接 */
    export const getFileUrl = (fileId: string) => `/api/Download/GetFile?id=${fileId}`

    /** 获取导出文件下载链接 */
    export const getExportFileUrl = (fileId: string) => `${window.location.origin}/api/Download/Get?id=${fileId}`

    export interface ICustomUploadParams {
        type: string,
        relationId?: number,
        sessionId?: NString,
        demand?: number
    }

    export interface IUploadViewModel {
        /** GUID */
        Id: string
    }
}
export default CustomUploadApi
